module.exports = __webpack_public_path__ + "media/images/common/ico-magazine-028f52c6c269e16df6de335ce34a0cf2.svg";